





import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../../store/edit';

export default Vue.extend({
	name: 'OzakazkaProvozovnaSelect',
	props: {
		storeUri: { type: String, default: null },
		isDisabled: { type: Boolean, default: false },
	},
	computed: {
		...genVuexComputeds(store),
	},
	// LP/TODO: Odkomentovat jakmile bude hotovy BE + pridat @update:value, actions, pokud treba doplnit chovani a zavislosti dle DMS2
	// methods: {
	// 	...mapActions(DMS_MODULE, {
	// 		// TODO: KR - zatim zadna zmena nenastava
	// 		provozovnaChange: types.actions.PROVOZOVNA_CHANGE,
	// 	}),
	// },
});
